import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Toggle from 'react-toggle';
//assets
import warningIcon from "img/warning-icone.svg";
//components
import Button from "pages/Quotes/components/generics/Button";
import Loader from "pages/Quotes/components/generics/Loader";
import PaymentTermDropdown from "./PaymentTermDropdown";
import { IsNullOrEmpty } from "utils/StringNullOrEmpty";
import { Column, Row } from "components/Layout/Grid";
import CDCloseButton from 'components/CDCloseButton';
import { Visibility } from "components/Visibility";
import toast from 'components/Toast/dispatch';
import Text from 'components/Text';
//services
import { PaymentMethodServices } from "services/paymentMethod.service";
import QuoteSevices from "services/quote.service";
//interfaces
import { DeadlineProps, IlistDistributionCenters, IMinimumBillingDeliveryDays, PaymentTermModalProps } from "./interface";
import { StatusType, SupplierStatusType } from 'components/Table/interface';
import { ProductSelectedProps } from "pages/Quotes/Details/interface";
import { IPaymentMethods } from "models/PaymentMethod";
import { IPaymentTerm } from "models/PaymentTerm";
import { IMinimumBilling } from "models/Quote";
//contexts
import { useDetailsQuoteContext } from "contexts/DetailsQuote";
import DistributionCenterContext from "pages/Quotes/store/distribution-center-context";
//styles
import { Header, ModalContainer, HeaderTitle, PaymentTermModalContent, PaymentTermModalBg, PaymentTermModalHeader, PaymentTermModalItensInfo, PaymentTermModalPaymentTerm } from "./style";
import "./style.css";
//others
import { isBefore } from 'date-fns';
import { currencyOutputNumber } from "utils/CurrencyOutput";
import KeycloakPubServiceInstance from "services/keycloakpubsub.service";

const PaymentTermModal = (props: PaymentTermModalProps) => {
  const {
    handleChangeProductSelected,
    distributionCenterSelected,
    allBudgetsSavedInQuote,
    newProductSelected,
    productSelected,
    isEditingQuote,
    paymentMethods,
    onCloseAction,
    quantityItems,
    popState,
    quoteId
  } = props;
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [selectedPaymentTermList, setSelectedPaymentTermList] = useState<IPaymentTerm[]>([]);
  const [paymentTermError, setPaymentTermError] = useState<any>([]);
  const [busy, setBusy] = useState(false);
  const [initialLoader, setInitialLoader] = useState(true);
  const [switchState, setSwitchState] = useState<boolean>(false);
  const [shouldCleanSelected, setShouldCleanSelected] = useState(false);
  const [defaultValueForDropdown, setDefaultValueForDropdown] = useState();
  const [minimumBillingDeliveryDays, setMinimumBillingDeliveryDays] = useState<IMinimumBillingDeliveryDays>();
  const [deadline, setDeadline] = useState<DeadlineProps[]>([]);
  const [paymentListError, setPaymentListError] = useState<string[]>([]);

  const listDistributionCenters = minimumBillingDeliveryDays?.listDistributionCenters;
  const ddd = minimumBillingDeliveryDays?.distributionCentersNotWrittenoff;

  const totalAllDc = minimumBillingDeliveryDays?.totalAllDistributionCenters ? currencyOutputNumber(minimumBillingDeliveryDays?.totalAllDistributionCenters) : '';

  const navigate = useNavigate();
  const _quoteServices = new QuoteSevices();
  const context = useContext(DistributionCenterContext);
  const { quoteDetail, setQuoteDetail, setModalPaymentTermModal, isQuoteExpired } = useDetailsQuoteContext();
  const isQuoteSentOrUpdated = quoteDetail?.status === StatusType.SENT || quoteDetail?.status === StatusType.UPDATED;

  const selectedDcs = productSelected.filter((item: any, index: number, selectedArray: any) =>
    selectedArray.findIndex((i: any) => i.distributionCenter == item.distributionCenter) == index);
  const dcList = selectedDcs?.map((dc: any) => dc.distributionCenter);

  let minimumBillingData: IMinimumBilling = {
    quotationId: quoteId,
    distributionCenters: dcList.join(","),
    distributionCenterSelected: distributionCenterSelected ?? ""
  };

  useEffect(() => {
    async function fetchList() {
      const paymentMenthod = await new PaymentMethodServices().getPaymentMethodListByName(); 

      let listWithNewKey = paymentMenthod.data.data.map((item: IPaymentMethods, index: number) => {
        item.paymentMethodName = item.protheusName; 
        item.protheusCode = item.paymentMethodUUID; 
        return item;
      }); 

      setPaymentMethodList(listWithNewKey); 
    }
    fetchList();
  }, []);

  useEffect(() => {
    if (switchState) {
      setShouldCleanSelected(true);
      setDefaultValueForDropdown(undefined);
      setSelectedPaymentTermList([]);
    } else {
      setShouldCleanSelected(false);
    }
  }, [switchState]);

  useEffect(() => {
    getMinimumBillingDeliveryDays();
  }, []);

  function handleSelectedPaymentTerm(distributionCenter: string, paymentTerm: any) { 
    let list = selectedPaymentTermList; 

    if (switchState) {
      const distributionCenters = selectedDcs;
      for (let item in distributionCenters) {
        const dc = distributionCenters[item].distributionCenter;
        list.push({
          "distributionCenter": dc,
          "paymentMethodUUID": paymentTerm.paymentMethodUUID,
        });
      }
      setDefaultValueForDropdown(paymentTerm);
    } 
    else {
      let paymentElement = list.find(payment => payment.distributionCenter === distributionCenter); 
      if (paymentElement !== undefined) {
        list = list.filter(payment => payment !== paymentElement);
      }
      let newPaymentTerm = {} as IPaymentTerm; 
      newPaymentTerm.distributionCenter = distributionCenter; 
      newPaymentTerm.paymentMethodUUID = paymentTerm?.paymentMethodUUID ?? ''; 
      list.push(newPaymentTerm);
    }
    setSelectedPaymentTermList(list);
  }

  const getDetailAfterSwitchingTab = async (quoteIdParam: string) => {
    KeycloakPubServiceInstance.subscribe(async () => {
      if (quoteDetail?.integrationMessages && quoteDetail?.integrationMessages?.length > 0) {
        const result = await _quoteServices.quoteDetailsWithCD(quoteIdParam);

        if (result?.data && !result?.error && quoteDetail)
          setQuoteDetail({ ...quoteDetail, integrationMessages: result.data.integrationMessages, status: result.data.status, distributionCentersList: result.data.distributionCentersList });
      }
    });
  };

  const handleFinally = () => {
    setBusy(false);

    if (isQuoteSentOrUpdated)
      getDetailAfterSwitchingTab(quoteId);

    if (newProductSelected && newProductSelected.length > 0 && isQuoteSentOrUpdated)
      handleChangeProductSelected!();

    setModalPaymentTermModal(false);

    allBudgetsSavedInQuote!(undefined, false, true);
  };

  function handleSubmit(event: any) {
    event.preventDefault();
    const selectedList = selectedPaymentTermList.map((item: any) => {
      return item.distributionCenter;
    });

    const paymentList = deadline.map((item: DeadlineProps) => {
      if (!IsNullOrEmpty(item.paymentTerm) && Number(item.paymentTerm) > 0 && Number(item.paymentTerm) < 99)
        return item.dcName;
    });

    const errorList = dcList.filter((item: any) => {
      return !selectedList.includes(item);
    });

    const errorPaymentList = dcList.filter((item: any) => {
      return !paymentList.includes(item);
    });

    if (errorList.length > 0 || errorPaymentList.length > 0) {
      setPaymentTermError(errorList);
      setPaymentListError(errorPaymentList);

      return;
    } else {
      setPaymentListError([]);
      setPaymentTermError([]);
    }

    if (deadline.length > 0)
      selectedPaymentTermList.map(payment => {
        payment.paymentTerm = deadline.find(d => d.dcName === payment.distributionCenter)?.paymentTerm;
      });

    const sequenceNumberList: Array<string> = [];
    productSelected.forEach((item: ProductSelectedProps) => {
      sequenceNumberList.push(item.sequenceNumber);
    });

    const quoteId = context.quoteId;
    const data: any = Object();
    data.sequenceNumbers = sequenceNumberList;
    data.paymentMethods = selectedPaymentTermList;
    setBusy(true);

    if (isEditingQuote) {
      _quoteServices.saveQuoteUnsentItems(quoteId, data).then((res) => {
        if (popState)
          popState(false);

        _quoteServices.quotationViewed(quoteId, false);
        handleFinally();
      }).catch((error) => {
        const errorMessage = error.response.data.data;
        errorSentQuote(errorMessage);
      });
    }
    else if (isQuoteExpired && distributionCenterSelected !== 'default' && quoteDetail?.supplierStatus === SupplierStatusType.ANSWERED_PORTAL) {
      _quoteServices.saveNegotiation(quoteId, data).then((res) => {
        if (popState)
          popState(false);
        _quoteServices.quotationViewed(quoteId, false);
        handleFinally();
      }).catch((error) => {
        const errorMessage = error.response.data.data;
        errorSentQuote(errorMessage);
      });
    }
    else {
      _quoteServices.saveQuotation(quoteId, data).then((res) => {
        if (res.status !== 200) {
          const errorMessage = res.data.data;
          errorSentQuote(errorMessage);
        } else {
          successSentQuote('/cotacoes-dashboard');
        }
      }).finally(() => {
        setModalPaymentTermModal(false);
        setBusy(false);
      });
    }
  }

  const getMinimumBillingDeliveryDays = async () => {
    const response = await _quoteServices.getMinimumBillingDeliveryDays(minimumBillingData);

    if (response) {
      const { data } = response;

      setMinimumBillingDeliveryDays(data);

      data.listDistributionCenters.map((i: IlistDistributionCenters) => {
        const newPaymentTerm = {
          dcName: i.distributionCenter,
          paymentTerm: !IsNullOrEmpty(i.deliveryDays) ? i.deliveryDays : i.distributionCenter === "BRA" ? "3" : "1"
        };
        deadline.push(newPaymentTerm);
      });
      setDeadline(deadline);

      setInitialLoader(false);
    }
  };

  const successSentQuote = (route: string) => {
    toast.successMoney(
      "Item(s) enviado(s) com sucesso.\n Pesquise pelo código para consultar o status da cotação."
    );
    if (quoteDetail?.supplierStatus !== SupplierStatusType.ANSWERED_PORTAL) {
      navigate(route, { state: { redirectQuote: true } });
    } else {
      onCloseModal();
    }
  };

  const successSentNegotiation = (route: string) => {
    toast.success(
      "Solicitação de negociação enviada!"
    );
    navigate(route, { state: { redirectQuote: true } });
  };

  const errorSentQuote = (error: string) => {
    toast.error(error);
  };

  const onCloseModal = () => {
    onCloseAction();
    document.body.style.overflow = "visible";
  };

  const header = (
    <PaymentTermModalHeader>
      <Header>
        <Row>
          <HeaderTitle>CONDIÇÕES COMERCIAIS</HeaderTitle>
        </Row>
        <Row>
          <CDCloseButton onClick={() => onCloseModal()} />
        </Row>
      </Header>
    </PaymentTermModalHeader>
  );

  const listQuoteNotDownloaded = minimumBillingDeliveryDays?.distributionCentersNotWrittenoff;
  const quoteNotDownloaded = listQuoteNotDownloaded && listQuoteNotDownloaded?.length < 1 ? false : true;

  const dcOptions = selectedDcs.map((item: any, index: number) => {
    return <PaymentTermDropdown
      deadline={deadline}
      setDeadline={setDeadline}
      key={item.distributionCenter}
      dcName={item.distributionCenter}
      paymentListError={paymentListError}
      paymentTermError={paymentTermError}
      paymentMethodList={paymentMethodList}
      paymentMethods={paymentMethods ?? []}
      defaultValue={defaultValueForDropdown}
      setPaymentListError={setPaymentListError}
      shouldCleanSelected={shouldCleanSelected}
      handleSelectedPaymentTerm={handleSelectedPaymentTerm}
      quoteNotDownloaded={ddd ? ddd?.includes(item.distributionCenter) : false}
      listDistributionCenters={listDistributionCenters?.find((x: any) => x.distributionCenter === item.distributionCenter)}
    />;
  });

  const countItemsRequested = isEditingQuote ? quantityItems : quoteDetail?.itemsCount;

  return (
    <PaymentTermModalBg className="bg-modal">
      <PaymentTermModalContent className={`relative max-w-100 max-h-100 bg-white`}>
        <ModalContainer>
          {header}
          <Visibility visible={initialLoader}>
            <div className="modaLoader">
              <Loader withPadding={false} size={70} color="#0E4C54" />
            </div>
          </Visibility>
          <Visibility visible={!initialLoader}>
            <PaymentTermModalItensInfo>
              <Row className="itemInfoTitle">
                <Text>Resumo de itens</Text>
              </Row>
              <Row className="itemIndicators">
                <Column>
                  <Text className="itemIndicatorTitle">Solicitados</Text>
                  <Text className="itemIndicatorNumber">{countItemsRequested}</Text>
                </Column>
                <Column>
                  <Text className="itemIndicatorTitle">Respondidos</Text>
                  <Text className="itemIndicatorNumber">{productSelected.length}</Text>
                </Column>
                <Column>
                  <Text className="itemIndicatorTitle">Itens não respondidos</Text>
                  <Text className="itemIndicatorNumber">
                    <Visibility visible={countItemsRequested - productSelected.length > 0}>
                      <img src={warningIcon} alt="warningIcon" className="warningIcon" />
                    </Visibility>
                    {countItemsRequested - productSelected.length}
                  </Text>
                </Column>
              </Row>
            </PaymentTermModalItensInfo>
            <PaymentTermModalPaymentTerm>
              <Row className="paymentTermTitle">
                <Text>Prazo de pagamento</Text>
                <Text>Total (todos os CD's)</Text>
              </Row>
              <Row className="paymentTermValue">
                <Text>Solicitado pelo cliente:  {quoteDetail?.paymentMethodName}</Text>
                <Text>{totalAllDc}</Text>
              </Row>
              <Row className="paymentTermLabels">
                <label>CD</label>
                <label>Prazo de pag. obrigatório</label>
                <label>Prazo entrega</label>
                <label>Total (por CD)</label>
              </Row>
              <Column>
                {dcOptions}
              </Column>
              <div className="notDownloaded">
                <Visibility visible={quoteNotDownloaded}>
                  <Row>
                    <span>*Essa cotação não foi baixada para o(s) CD(s): {listQuoteNotDownloaded?.join(",")}</span>
                  </Row>
                  <Row>
                    <span>Caso opte por enviar, a cotação para esse(s) CD(s) sera colocada em fila e ficará em processamento até atualização do status </span>
                  </Row>
                </Visibility>
              </div>
              <Visibility visible={selectedDcs.length > 1}>
                <Row className="sameValueToggle">
                  <Toggle
                    id='cheese-status'
                    defaultChecked={false}
                    icons={false}
                    onChange={(e) => setSwitchState(e.target.checked)} />
                  <label htmlFor='cheese-status'>
                    Aplicar o mesmo prazo de pagamento para todos os CD's
                  </label>
                </Row>
              </Visibility>
            </PaymentTermModalPaymentTerm>
            <Row style={{ marginTop: '8px', alignItems: 'baseline' }}>
              <div>
                <span className="email">Cotação será enviada para o(s) e-mail(s): </span>{minimumBillingDeliveryDays?.emails}<br></br>
              </div>
            </Row>
            <div style={{ marginTop: 25 }}>
              <Button
                label={<div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span>Finalizar envio da cotação</span>
                  <Visibility visible={busy}>
                    <span style={{ position: 'absolute', right: '0' }}>
                      <Loader withPadding={false} size={25} color="white" />
                    </span>
                  </Visibility>
                </div>}
                onClick={(event: any) => !busy && handleSubmit(event)}
              />
            </div>
          </Visibility>
        </ModalContainer>
      </PaymentTermModalContent>
    </PaymentTermModalBg>
  );
};

export default PaymentTermModal;